import React from 'react';
import { colors } from '../styles/styles';

// Styles
const styles = {
  container: {
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    padding: '8px 8px',
    marginTop: '0px',
    marginBottom: '8px',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
  tagsWrapper: {
    display: 'inline-flex',
    gap: '8px',
    paddingBottom: '4px',
    transition: 'opacity 0.3s ease'
  },
  tagButton: (isActive) => ({
    backgroundColor: isActive ? colors.accent.white : `${colors.accent.white}10`,
    color: isActive ? 'black' : colors.accent.white,
    border: 'none',
    borderRadius: '16px',
    padding: '8px 14px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s cubic-bezier(0.2, 0, 0, 1)',
  }),
  clearButton: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
    color: '#FF3B30',
    border: 'none',
    borderRadius: '16px',
    padding: '8px 14px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s cubic-bezier(0.2, 0, 0, 1)',
  },
  hideScrollbar: `
    /* Hide scrollbar for Chrome/Safari */
    div::-webkit-scrollbar {
        display: none;
    }
  `
};

/**
 * Individual tag button component
 */
const TagButton = ({ tag, isActive, onClick }) => (
  <button
    key={tag}
    onClick={onClick}
    style={styles.tagButton(isActive)}
  >
    {tag}
  </button>
);

/**
 * Clear All button component
 */
const ClearButton = ({ onClick }) => (
  <button 
    onClick={onClick}
    style={styles.clearButton}
  >
    Clear All
  </button>
);

/**
 * A reusable horizontal scrollable tag filter component
 * 
 * @param {Object} props
 * @param {Array} props.popularTags - Array of tag objects with a 'tag' property
 * @param {Array} props.activeFilters - Array of currently active tag strings
 * @param {Function} props.toggleTag - Function to toggle a tag's active state
 * @param {Function} props.clearFilters - Function to clear all active filters
 * @param {boolean} props.reserveSpaceWhenEmpty - Whether to reserve space even when no tags exist
 */
const TagFilters = ({ 
  popularTags = [], 
  activeFilters = [], 
  toggleTag, 
  clearFilters,
  reserveSpaceWhenEmpty = false
}) => {
  const hasActiveTags = activeFilters.length > 0;
  const showComponent = popularTags.length > 0 || reserveSpaceWhenEmpty;
  
  if (!showComponent) return null;
  
  return (
    <div style={{
      ...styles.container,
      height: popularTags.length > 0 ? 'auto' : reserveSpaceWhenEmpty ? '62px' : 'auto',
      overflowX: popularTags.length > 0 ? 'auto' : 'hidden',
    }}>
      <style>
        {styles.hideScrollbar}
      </style>
      <div className="fade-in" style={{
        ...styles.tagsWrapper,
        opacity: popularTags.length > 0 ? 1 : 0,
      }}>
        {popularTags.map(({ tag }) => (
          <TagButton 
            key={tag}
            tag={tag}
            isActive={activeFilters.includes(tag)}
            onClick={() => toggleTag(tag)}
          />
        ))}
            
        {/* Clear All button - only visible when there are active filters */}
        {hasActiveTags && (
          <ClearButton onClick={clearFilters} />
        )}
      </div>
    </div>
  );
};

export default TagFilters; 